<template>
  <div>
    <page-title>{{ PageTitle }}</page-title>

    <loading v-if="loading"></loading>
    <section-block v-else>
      <template slot="header">
        <filter-bar
          :showSearch="true"
          :showFilter="true"
          resource="Events"
          :filterOptions="interestGroups"
          v-if="showSearch"
          filter-url-param="categories"
        />
      </template>
      <template slot="actions">
        <inline-list :ordered="false">
          <li>
            <block-link
              href="#"
              @click="toggleGrid(true)"
              :class="{ active: gridLayout, inactive: !gridLayout }"
              title="View as a grid"
            >
              <icon name="grid" width="18" height="18" />
            </block-link>
          </li>
          <li>
            <block-link
              href="#"
              @click="toggleGrid(false)"
              :class="{ active: !gridLayout, inactive: gridLayout }"
              title="View as a list"
            >
              <icon name="list" width="18" height="18" />
            </block-link>
          </li>
        </inline-list>
      </template>

      <section>
        <div v-if="events.length < 1">
          <p>Sorry, there are no events listed at the moment</p>
        </div>

        <inline-list
          v-else
          :ordered="true"
          :class="{ row: !gridLayout }"
          withPadding
          role="list"
        >
          <li
            v-for="event in events"
            :key="event.id"
            :class="{
              'col-xs-12 col-md-4': gridLayout,
              'col-xs-12': !gridLayout,
            }"
            role="listitem"
          >
            <card-grid
              v-bind="event"
              :date="event.start_date"
              @click="handleClick"
              v-if="gridLayout"
              :likes="event.favourite_count"
            ></card-grid>
            <card-list
              v-bind="event"
              :date="event.start_date"
              @click="handleClick"
              :asLink="true"
              :likes="event.favourite_count"
              v-else
            ></card-list>
          </li>
        </inline-list>
      </section>
      <pagination
        v-if="pagination.last_page > 1"
        :pagination="pagination"
        @onPageClick="gotoPage"
      />
    </section-block>
  </div>
</template>

<script>
// TODO: Load up list of stories, on click go to story, using state
import CardGrid from "@/components/Containers/BaseCardGrid";
import CardList from "@/components/Containers/BaseCardList";
import InlineList from "@/components/Lists/InlineList";
import BlockLink from "@/components/Links/BaseLinkBlock";
import Pagination from "@/components/pagination";
import querySearch from "@/mixins/querySearch";
import { mapState } from "vuex";

export default {
  components: {
    CardGrid,
    CardList,
    InlineList,
    Pagination,
    BlockLink,
  },
  mixins: [querySearch],
  created() {
    const vm = this;
    this.$store.commit("Events/SET_PUBLISHED_FILTER", true);
    // from querySearch mixin
    this.setFiltersFromQuery('Events')
    this.$store
      .dispatch("Events/list", { isFlat: true })
      .then((resp) => (this.loading = false));
    // also need categories
    this.$store.dispatch("InterestGroups/list", { flat: true });
    const { tab } = vm.$route.params;
    if (!vm.$route.meta.openPanel) {
      vm.$store.commit("documents/setTabFilter", tab);
    }
  },
  data() {
    return {
      PageTitle: "Upcoming Events",
      loading: true,
      showSearch: true,
    };
  },
  computed: {
    ...mapState("Events", ["events", "pagination"]),
    ...mapState({
      interestGroups: (state) => state.InterestGroups.collection,
    }),
    gridLayout: {
      get() {
        return this.$store.state.Events.gridLayout;
      },
      set(newVal) {
        this.$store.dispatch("Events/toggleGrid", newVal);
      },
    },
  },
  methods: {
    handleClick(eventId) {
      this.$router.push({
        name: "EventsSinglePage",
        params: { id: eventId },
      });
    },
    toggleGrid(val) {
      this.gridLayout = val;
    },
    gotoPage(page) {
      this.loading = true;
      this.$store.dispatch("Events/list", { page }).then((resp) => {
        this.loading = false;
        window.scroll(0, 0);
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
